<template>
    <div>
        <div class="chart" id="churl" ref="chartRef" />
    </div>
</template>
  
<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([GridComponent, BarChart, CanvasRenderer]);


export default {

    components: {

    },
    props: {
        chartData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            option: {},
            chartDom: null,
            myChart: null
        };
    },
    mounted() {
        this.chartDom = document.getElementById('churl');
        this.myChart = echarts.init(this.chartDom);

        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow',
                },
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                data: this.chartData.map(el => el.date)
            },
            yAxis: {
                type: 'value'
            },
            legend: {
                icon: 'circle',
                bottom: 20,
                left: 50
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100
                },

            ],
            series: [
                {
                    data: this.chartData.map(el => el.result),
                    type: 'bar',
                    showBackground: false,
                    color: [
                        '#004F96',
                    ],
                    backgroundStyle: {
                        color: 'rgba(180, 180, 180, 0.2)'
                    }
                }
            ]
        };
        this.myChart.on('click', (params) => {
           
            this.$emit('drilldown', { chart: 'EarlyChurnRate', value: params.name })
        })
        this.option && this.myChart.setOption(this.option);
    }
}

</script>
  
<style scoped>
.chart {
    height: 100vh;
}
</style>
  
<style>
body {
    margin: 0;
}

#churl {
    height: 400px;
}
</style>